var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.23107 0C5.13134 -1.74385e-08 5.0316 0.0371234 4.95524 0.110613L2.61454 2.38348C2.46182 2.53122 2.46182 2.77138 2.61454 2.91912C2.76648 3.06762 3.01271 3.06686 3.16543 2.91988L5.23107 0.914451L7.2897 2.9123C7.44164 3.05928 7.68787 3.06004 7.84059 2.91155C7.99253 2.76305 7.99253 2.52364 7.84059 2.37591L5.50691 0.110613C5.43055 0.0371235 5.33081 1.74385e-08 5.23107 0Z",
    fill: "#2D3748"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.26893 9.84022C5.36866 9.84022 5.4684 9.7993 5.54476 9.71829L7.88546 7.21297C8.03818 7.05013 8.03818 6.7854 7.88546 6.62255C7.73352 6.45887 7.48729 6.4597 7.33457 6.62172L5.26893 8.83224L3.2103 6.63007C3.05836 6.46806 2.81213 6.46722 2.65941 6.6309C2.50747 6.79458 2.50747 7.05848 2.65941 7.22132L4.99309 9.71829C5.06945 9.7993 5.16919 9.84022 5.26893 9.84022Z",
    fill: "#2D3748"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortedIcon);
export default __webpack_public_path__ + "static/media/sorted_icon.1eac919632f2fd4cbe2299aefbc28893.svg";
export { ForwardRef as ReactComponent };